import {
    hasValue,
    isNullOrUndefined,
    setHtmlIdAttribute,
} from '../../../general/js/general-helpers';

export const initialiseEventCentreInstance =
    (clipTag, eventCenterParams) => (state) => {
        const { shotViewElement } = state;

        if (hasValue(eventCenterParams) && isNullOrUndefined(shotViewElement)) {
            return {
                ...state,
                shotViewElement: clipTag.eventCentre(eventCenterParams),
            };
        }

        return {
            ...state,
        };
    };

export const setClipTagContainerId = (
    liveShotViewConfig,
    clipTagContainerDiv
) => {
    if (!hasValue(liveShotViewConfig)) return;

    const { eventCentreParameters } = liveShotViewConfig;

    if (!hasValue(eventCentreParameters)) return;

    const { targetElement } = eventCentreParameters;

    setHtmlIdAttribute(clipTagContainerDiv, targetElement);
};

export const formatEventCentreParameters = (eventCentreParameters = null) => {
    const formattedParams = isValidEventCentreParameters(eventCentreParameters) ?
        {
            operator: eventCentreParameters.operator,
            sport: eventCentreParameters.sport,
            eventId: eventCentreParameters.eventId,
            targetModule: eventCentreParameters.targetModule,
            version: eventCentreParameters.imgaVersion,
            language: eventCentreParameters.imgaLanguage,
            targetElementSelector: `#${eventCentreParameters.targetElementSelector}`,
        } :
        {};

    if (!hasValue(formattedParams)) {
        return formattedParams;
    }

    if (hasValue(eventCentreParameters.environment)) {
        formattedParams.env = eventCentreParameters.environment;
    }

    if (hasValue(eventCentreParameters.contextView)) {
        formattedParams.initialContext = {
            view: eventCentreParameters.contextView,
        };
    }

    return formattedParams;
};

export const isValidEventCentreParameters = (eventCentreParameters = null) => {
    return (
        hasValue(eventCentreParameters) &&
        hasValue(eventCentreParameters.operator) &&
        hasValue(eventCentreParameters.sport) &&
        hasValue(eventCentreParameters.eventId) &&
        hasValue(eventCentreParameters.targetModule) &&
        hasValue(eventCentreParameters.imgaVersion) &&
        hasValue(eventCentreParameters.imgaLanguage) &&
        hasValue(eventCentreParameters.targetElementSelector)
    );
};
